<template>
  <main class="game-container">
    <DisCordBanner />
    <classify />
    <div class="section-title-box">
      <h2 class="show-container-title">{{ $t('lang041') }}</h2>
      <div class="live-sort-list">
        <a
          v-for="(game, index) in gameRecommendLabel"
          :key="index"
          :class="[
            'live-sort-list__item',
            { active: gameRecommendIndex === index }
          ]"
          href="javascript:;"
          @click="fetchGameList(index)"
        >
          {{ $t(game.title) }}
        </a>
      </div>
    </div>
    <ul class="game-list">
      <game-room-entrance
        v-for="(room, index) in gameList"
        :key="index"
        :room-info="room"
        class="game-room-item"
      />
    </ul>
    <div v-show="loading" class="bottom-loading">
      <img :src="require('@assets/img/page-loading.gif')" />
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import Classify from '@components/Classify';
import GameRoomEntrance from '@components/GameRoomEntrance';
import DisCordBanner from '@components/DisCordBanner';
import api from '@services';
import { getCountryCode } from '@assets/js/utils';

export default {
  scrollToTop: true,
  components: {
    Classify,
    GameRoomEntrance,
    DisCordBanner
  },
  data() {
    return {
      gameRecommendIndex: 0,
      loading: false,
      // 最后一页
      isLastPage: false,
      gameList: [],
      ignoreUids: []
    };
  },
  computed: {
    ...mapGetters(['gameRecommendLabel'])
  },
  async created() {
    if (process.client) {
      this.$store.dispatch('getGameClassifyList');

      const res = await api.getGamingList({
        countryCode: getCountryCode(this.$i18n.locale, true),
        tabType: '00',
        fetchNum: 50,
        lang: this.$i18n.locale
      });
      const gameList = res?.data || [];
      if (gameList && gameList.length > 0) {
        this.gameList = gameList;
        const ignoreUids = gameList.map((item) => item.owner);
        this.ignoreUids = ignoreUids;
      } else {
        this.$log &&
          this.$log.error('get game list error', {
            msg: JSON.stringify(gameList)
          });
      }
    }
  },
  mounted() {
    document.addEventListener('scroll', this.scroll);
    // 4k的显示器首屏不会有页面滚动，需要手动触发加载
    // this.scroll();
    if (window.assetsLoadMonitor) {
      window.assetsLoadMonitor.sendCustomKeyReport({
        type: 'first_screen_time', // 自定义打点类型， type参数不能是page_view_time 和 white_screen_time， 因为会和公共库pv和白屏打点冲突
        extra: {
          // 扩展信息， 业务按需传
          msg: '首屏时间',
          page: 'games/index'
        }
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.scroll);
  },
  methods: {
    fetchGameList(index) {
      if (index !== this.gameRecommendIndex) {
        this.gameList = [];
        this.ignoreUids = [];
        this.isLastPage = false;
        this.gameRecommendIndex = index;
      }
      if (this.loading || this.isLastPage) return;
      this.loading = true;
      const tabType = this.gameRecommendLabel[index].tabId;
      this.$api
        .getGamingList({
          countryCode: getCountryCode(this.$i18n.locale, true),
          tabType,
          fetchNum: 30,
          ignoreUids: this.ignoreUids.join('.'),
          lang: this.$i18n.locale
        })
        .then((res) => {
          const data = res?.data || [];
          this.isLastPage = +res.resCode >= 1 || data.length === 0;

          if (data && data.length >= 0) {
            this.gameList = this.gameList.concat(data);
            const ignoreUids = data.map((item) => item.owner);
            this.ignoreUids = this.ignoreUids.concat(ignoreUids);
          }
          this.loading = false;
          // 4k的显示器请求两次后还是不会有页面滚动，需要手动触发加载
          this.scroll();
        });
    },
    scroll() {
      const scrollHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const clientHeight =
        window.innerHeight ||
        Math.min(
          document.documentElement.clientHeight,
          document.body.clientHeight
        );

      if (clientHeight + scrollTop >= scrollHeight) {
        this.fetchGameList(this.gameRecommendIndex);
      }
    }
  },
  head() {
    return {
      title: this.$t('lang187'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('lang188')
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: "PLAYERUNKNOWN'S BATTLEGROUNDS, Mobile Legends, game live"
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.game-container {
  padding-top: 60px;
  max-width: 1340px;
  margin: 0 auto;

  .show-container-title {
    font-size: 28px;
    font-weight: 600;
    color: #2f3033;
    line-height: 40px;
    margin-bottom: 8px;
  }
}

.game-list {
  position: relative;
  overflow: hidden;
  margin-right: -25px;
}

.bottom-loading {
  margin-top: 20px;
  text-align: center;
}
</style>
